import React, { Suspense } from "react";

const LazyGiftcard = React.lazy(() => import("../containers/Giftcard"));

function Giftcard() {
	return (
		<Suspense fallback={<></>}>
			<LazyGiftcard />
		</Suspense>
	);
}

export { Giftcard };
